<template>
  <div class="bg-footer">
    <footer class="footer container-workspace mx-auto px-0 py-3">
      <div class="flex flex-wrap">
        <!-- Redes sociales -->
        <div class="sm:w-full w-full md:w-2/12 px-3 py-4 md:py-4 md:px-0">
          <h3 class="font-bold text-white mb-2">Síguenos:</h3>
          <ul class="list-social-networks flex flex-wrap items-center gap-6 px-2">
            <!-- x - antes twiter -->
            <li class="md:w-1/6">
              <a target="_blank" href="https://twitter.com/SFCsupervisor" title="Enlace a X">
                <!-- <a-icon type="twitter" /> -->
                <img src="@/assets/icons/x-twitter-brands.svg" alt="Enlace a X">
              </a>
            </li>
            <!-- instagram -->
            <li class="md:w-1/6">
              <a target="_blank" href="https://www.instagram.com/superfinanciera" title="Enlace a Instagram">
                <!-- <a-icon type="instagram" /> -->
                <img src="@/assets/icons/instagram-brands.svg" alt="Enlace a X">
              </a>
            </li>
            <!-- facebook -->
            <li class="md:w-1/6">
              <a target="_blank" href="https://es-la.facebook.com/superintendencia.financiera/"
                title="Enlace a Facebook">
                <!-- <a-icon type="facebook" theme="filled" /> -->
                <img src="@/assets/icons/facebook-brands.svg" alt="Enlace a Faecebook">
              </a>
            </li>
            <!-- Youtube -->
            <li class="md:w-1/6">
              <a target="_blank" href="https://www.youtube.com/user/superfinancieracol" title="Enlace a Youtube">
                <!-- <a-icon type="youtube" theme="filled" /> -->
                <!-- <img src="@/assets/icons/youtube-brands.svg" alt="Enlace a X"> -->
                <img src="@/assets/icons/youtube-brands.svg" alt="Enlace a Youtube">
              </a>
            </li>
            <!-- LinkedIn -->
            <li class="md:w-1/6">
              <a target="_blank" href="https://co.linkedin.com/company/superfinanciera" title="Enlace a linkedin">
                <!-- <a-icon type="linkedin" /> -->
                <!-- <img src="@/assets/icons/linkedin-brands.svg" alt="Enlace a X"> -->
                <img src="@/assets/icons/linkedin-brands.svg" alt="Enlace a Linkedin">
              </a>
            </li>
            <li class="md:w-1/6">
              <a target="_blank" href="https://open.spotify.com/show/1bDPMtanEKBOI09j3DQKGM" title="Enlace a Spotify">
                <!-- <a-icon type="spotify" theme="filled" /> -->
                <img src="@/assets/icons/spotify-brands.svg" alt="Enlace a Spotify">
              </a>
            </li>
          </ul>
        </div>
        <!-- Ubicación -->
        <div class="sm:w-full md:w-2/12 py-4 px-3">
          <h3 class="font-bold text-white">Superintendencia </br> Financiera de Colombia</h3>
          <p class="font-bold">Dirección:</p>
          <a href="https://www.superfinanciera.gov.co/10097627" target="_blank">
            Calle 7 No. 4 - 49 Bogotá, D.C.
          </a>
          <h3 class="font-bold text-white">Código postal: <span class=" font-normal">111711</span></h3>
        </div>
        <!-- Conmutador -->
        <div class="sm:w-full md:w-3/12 py-4 px-3">
          <h3 class="font-bold text-white">Conmutador:</h3>
          <p> +57 601 594 0200 - +57 601594 0201 - +57 601 350 8166 </p>
          <h3 class="font-bold text-white mt-2">Línea gratuita nacional:</h3>
          <p>018000 120 100</p>
          <h3 class="font-bold text-white">Fax: <span class=" font-normal">+57 601350 79 99 - 601350 5707</span></h3>
          <h3 class="font-bold text-white mt-2">Centro de Contacto:</h3>
          <p>+57 601307 8042</p>
          <ul>
            <li class="mt-4">Lunes a viernes de 8:00 a.m. a 6:00 p.m. jornada continua</li>
          </ul>
          <h3 class="font-bold text-white mt-2">Numeral abreviado <span class=" font-normal">#903</span></h3>
          <h3 class="font-bold text-white mt-2">Línea anticorrupción:</h3>
          <p>+57 601 594 0200 extensiones 2334 y 233503</p>
        </div>
        <!-- Información -->
        <div class="sm:w-full md:w-3/12 py-4 px-3">
          <div class="inconformidad mb-2">
            <a href="https://smart.superfinanciera.gov.co/" target="_blank" class="underline">Inconformidad con una
              entidad vigilada:</a>
            <p>Si necesita instaurar una queja por productos o servicios ofrecidos por una entidad vigilada por la SFC.
            </p>
          </div>
          <div class="pqrsdf">
            <a href="https://www.superfinanciera.gov.co/formulesuqueja/faces/registro/registro.xhtml" target="_blank"
              class="underline">PQRSDF por servicios de la SFC:</a>
            <p>Si quiere instaurar una petición, queja,
              reclamo, solicitud, denuncia o felicitación con relación a los servicios o a la atenciónde esta
              Superintendencia.</p>
          </div>

          <div class="emails my-6">
            <p>Correo para notificaciones judiciales</p>
            <p>Para el envío de notificaciones judiciales
              únicamente está habilitado el correo
              electrónico </p>
            <a href="mailto:notificaciones_ingreso@superfinanciera.gov.co"
              class=" underline">notificaciones_ingreso@superfinanciera.gov.co</a>
            <p>El horario de este canal es de 8:15 a.m. a 5:00 p.m.</p>
          </div>

          <div>
            <h3 class="font-bold text-white">Correo institucional:</h3>
            <a class="underline" href="mailto:super@superfinanciera.gov.co">super@superfinanciera.gov.co</a>
          </div>

        </div>
        <!-- Horarios -->
        <div class="sm:w-full md:w-2/12 px-3 py-4 md:py-4 md:pl-3 md:pr-0">
          <h3 class="font-bold text-white mb-2">Horario de atención</h3>
          <ul>
            <li>
              <a href="https://www.superfinanciera.gov.co/10083733" target="_blank" class="underline"><strong>Punto Ciudadano:</strong></a>
    <br><br>
    Lunes a viernes (días hábiles) de 8:15 a.m. a <br>4:15 p.m. jornada continua. 
            </li>
            <li>              
             <strong>Recepción de correspondencia por medios electrónicos:</strong>
    <br><br>
    Lunes a viernes (días hábiles) de 8:15 a.m. a <br>4:45 p.m. jornada continua
            </li>
          </ul>
        </div>
      </div>
    </footer>
    <div style="height: 60px; padding: 10px;" class="w-full flex justify-center items-center bg-blue">
      <div class="h-full w-11/12 flex items-center container-workspace mx-auto">
        <LogoCOGOV class="w-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import LogoCOGOV from '@/components/Brand/LogoCOGOV'
export default {
  components: {
    LogoCOGOV
  }
}
</script>

<style>
.bg-footer {
  background: #4B4B4B;  
}
.footer {
  background: #4B4B4B;
  color: white !important;   
  text-align: left;
}

.footer ul li {
  list-style: disc;
  margin-bottom: 1rem;
}

.footer ul li span {
  display: inline-block;
}

.list-social-networks li {
  list-style: none !important;
  margin-bottom: 0rem !important;
}

.list-social-networks li img {
  height: 25px;
}

.footer ul {
  list-style-position: outside; /* El marcador queda fuera del bloque */
  padding-left: 1.5rem; /* Asegura buena separación */
}

.footer ul li {
  list-style-type: disc;
  margin-bottom: 1rem;
  display: list-item; /* Asegura que el marcador se muestre correctamente */
  vertical-align: top;
}

.footer ul li::marker {
  vertical-align: top;
  font-size: 1rem; /* opcional: puedes ajustar el tamaño del punto */
}

.footer a:hover,
.bg-footer a:hover {
  color: inherit !important;
  text-decoration: inherit !important;
  background: inherit !important;
  opacity: inherit !important;
  filter: none !important;
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}

/* Si usas clases underline, evita que se subraye al hacer hover */
.footer a.underline:hover,
.bg-footer a.underline:hover {
  text-decoration: underline !important;
}

</style>